import { createSlice } from "@reduxjs/toolkit";
import { actionAdditionalKycData } from "../action/ComplianceAction";

const initialState = {
  value: 0,
  selectedAccount: {
    id: null,
    email: null,
  },
  currentStep: 0,
  formStep: "update_account",
  additionalKycData: null,
  additionalKycDataPending: false,
  additionalKycDataError: false,
};

export const complianceSlice = createSlice({
  name: "compliance",
  initialState,
  reducers: {
    saveSelectedAccount: (state, { payload }) => {
      state.selectedAccount = payload;
    },
    saveCurStep: (state, { payload }) => {
      state.currentStep = payload;
    },
    saveFormStep: (state, { payload }) => {
      state.formStep = payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(actionAdditionalKycData.pending, (state) => {
        state.additionalKycDataPending = true;
      })
      .addCase(actionAdditionalKycData.fulfilled, (state, { payload }) => {
        state.additionalKycData = payload.data;
        state.additionalKycDataPending = false;
      })
      .addCase(actionAdditionalKycData.rejected, (state, { payload }) => {
        state.additionalKycDataPending = false;
        state.additionalKycDataError = true;
      });
  },
});

// Action creators are generated for each case reducer function
export const { saveSelectedAccount, saveCurStep, saveFormStep } =
  complianceSlice.actions;

export default complianceSlice.reducer;
